export default __webpack_public_path__ + "static/media/dragonfly_logo.2721cf29.jpg";